import uuid from 'node-uuid'
import 'Data/ServerSource'
import '../Map/Base'
import { InvalidArgumentError } from '../../errors'

/** @namespace GIS.Data */
NS("GIS.Data");

/**
 * GIS.Data.Layers source
 * @class
 * @extends Data.ServerSource
 */
GIS.Data.Layers = Class(Data.ServerSource, /** @lends GIS.Data.Layers.prototype */ {
    url: "GIS/Web/Layers/",

    fields: [
        { name: "id", title: "id" }, // string
        { name: "projectionid", title: "projectionid" }, // int
        { name: "name", title: "name" }, // string
        { name: "style", title: "style" }, // json
        { name: "options", title: "options" },
        { name: "jsclass", title: "jsclass" }, // string
        { name: "serviceid", title: "serviceid" },
        { name: "serviceoptions", title: "serviceoptions" }
    ],
    /**
     * Transforms source item to layer options.
     * @param {Object} item
     * @returns {{class: *, options: *}}
     */
    toLayerOptions(item) {
        assert(_.isObject(item) && !_.isEmpty(item), "invalid or empty item", InvalidArgumentError);
        assert(!_.isEmpty(item.projection), "undefined layer projection", InvalidArgumentError);
        assert(!_.isEmpty(item.jsclass), "undefined layer class", InvalidArgumentError);

        const layerClass = item.jsclass;
        const service = item.service;
        var projection = item.projection;

        var keys = [
            'layerid', 'filter_', 'style', 'minZoom', 'maxZoom', 'opacity', 'clusterStrategy', 'clusterDistance',
            'loadingStrategy',
            'dataPrimaryKeyName',
            'dataGeometryName',
            'dataGeometryNameMap',
            'geometryName',
            'ds',
            'dsLimit',
            'dsMethod',
            'asImage'
        ];

        const options = _.merge({
                title: item.name,
                projection: GLONASS_PROJ, // always epsg:4326 for server layers
                data: item,
                name: Util.coalesce(item.id, uuid.v4())
            },
            Util.pickOptions(item, keys),
            Util.pickOptions(item.options, keys)
        );

        if (!_.isEmpty(service)) {
            projection = !_.isEmpty(service.projection) ? service.projection : projection;

            _.merge(
                options, {
                    projection: [projection.codename, projection.code].join(':')
                },
                Util.pickOptions(service, ["url", "format"]),
                Util.pickOptions(service.options, _.keys(service.options)),
                Util.pickOptions(item.serviceoptions, _.keys(item.serviceoptions))
            );

            if (options.tileSize != null) {
                options.tileSize = String(options.tileSize).split(",").map(_.ary(_.parseInt, 1));
                if (options.tileSize.length === 1) {
                    options.tileSize = [ options.tileSize, options.tileSize ];
                }
            }
        }

        // add options specific for each supertype
        switch (layerClass) {
            case "GIS.Map.Layer.GlonassVector":
                break;
            case "GIS.Map.Layer.Tile":
                break;
            case "GIS.Map.Layer.WFS":
                break;
            case "GIS.Map.Layer.WMS":
                break;
            case "GIS.Map.Layer.mosaic_rgb":
                break;
        }

        return {
            "class": layerClass,
            options
        };
    }
});
